import { SortingOrder } from "@shared/types";
import { ColumnSpan, ColumnType } from "@shared/common/CardsList/types";
import { ReactNode } from "react";

export enum ExpandCollapseDirection {
  EXPAND,
  COLLAPSE,
}

export type CardSorterColumn = Omit<ColumnType<any>, "render">;

export interface CardSortersProps {
  columnNames?: ReactNode[];
  columnSpans?: ColumnSpan[];
  showExpandCollapse?: boolean;
  onExpandCollapseClick?: () => void;
  sortOrder?: SortingOrder;
  sortColumnKey?: string | number;
  columns?: CardSorterColumn[];
  setSortColumnKey?: (key: string | number) => void;
  setSortOrder?: (sortOrder: SortingOrder) => void;
  style?: any;
  sorterStyle?: any;
}
